import { setGetInviteByIdAction } from '../action';
import { getInviteById } from '../api/getInviteById';

export const setGetInviteById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getInviteById(params);
            dispatch(setGetInviteByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}